import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../api/axios-instance';
import { FileMetadataModel } from '../models/file-metadata.model';
import { IdFile } from '../models/id-file.model';

export const getBlobFile = createAsyncThunk<
  IdFile,
  Pick<FileMetadataModel, 'downloadLink' | 'name' | 'id'>
>(
  'app/get-image-blob',
  async ({
    downloadLink,
    name,
    id,
  }: Pick<
    FileMetadataModel,
    'downloadLink' | 'name' | 'id'
  >): Promise<IdFile> => {
    const { data }: AxiosResponse<Blob> = await axiosInstance.get(
      downloadLink,
      {
        responseType: 'blob',
        omitAuthHeader: true,
      }
    );
    const blob = new Blob([data]);
    return {
      id,
      file: new File([blob], name),
    };
  }
);
